{
  "iconStyle": {
    "alignment": "Alinhamento",
    "screen": "Tela alinhada",
    "north": "Alinhado ao norte"
  },
  "mapObjectSelectionHelpers": {
    "layerNotVisible": {
      "message": "O objeto de mapa selecionado está em uma camada visualmente oculta",
      "cta": "Alternar visibilidade"
    },
    "objectOnDifferentLevel": {
      "message": "O objeto de mapa selecionado está em um nível diferente",
      "cta": "Nível do switch"
    },
    "layerNotVisibleAndObjectOnDifferentLevel": {
      "message": "O objeto de mapa selecionado está em uma camada visualmente oculta e em um nível diferente",
      "cta": "Alterne a visibilidade e o nível do switch"
    }
  },
  "dates": {
    "objectDetails": {
      "noRangesAvailable": "Sem intervalos",
      "rangeAvailable": "1 faixa",
      "rangesAvailable": "intervalos de {{ rangesAmount }}",
      "add": "Adicionar intervalos de data e hora",
      "noDataAvailable": "Não há dados disponíveis"
    },
    "dateRangeAttribute": {
      "name": "Nome",
      "dates": "Datas",
      "time": "Hora"
    },
    "startDate": "Data de início",
    "attributeName": "Intervalo de data e hora (por exemplo, turnos)",
    "attributeInfoBox": {
      "title": "Exemplos de valores de dados",
      "infoBlurb": "Use esse atributo para definir o intervalo de datas e horas em que você deseja que o objeto do mapa fique visível. Por exemplo, “<strong>John's Morning Turno</strong>” será exibido entre <strong>9h45</strong> e <strong>17h45</strong>. Essa visibilidade também pode ser determinada pela seleção no intervalo de data e hora do mapa no canto inferior direito do mapa.",
      "johnsMorningShift": "O turno matinal de John"
    },
    "attributeSettings": "Configurações de atributos",
    "addRange": "Adicionar intervalo",
    "mapObjectDateFiltered": "O objeto de mapa selecionado é filtrado pela data selecionada",
    "mapObjectDateFilteredCta": "Remover o filtro de data",
    "tooltip": {
      "title": "Data e intervalo de tempo recorrentes",
      "blurb": "Use esse recurso para definir intervalos de repetição para um evento específico em datas que ocorrem regularmente. Por exemplo, turnos de funcionários"
    },
    "calendarTooltip": "Filtro de mapa de data e hora"
  },
  "ranges": "intervalos",
  "digitalTwin": {
    "loading": {
      "header": "Construindo seu gêmeo digital",
      "message": "Isso pode levar alguns instantes"
    },
    "restarting": {
      "header": "Opa!",
      "message": "Desculpe, algo deu errado. Estamos reconectando você ao gêmeo digital..."
    }
  },
  "styles": {
    "arrows": {
      "sameAsLine": "Igual à linha",
      "custom": "Personalizado"
    },
    "customImage": "Imagem personalizada",
    "customColour": "Cor personalizada",
    "selectImage": "Selecione uma imagem personalizada",
    "customImagePerModel": "Você só pode fazer upload de 1 imagem por modelo. Você pode substituir sua seleção abaixo.",
    "customImageAspectRatio": "Esta imagem não tem a proporção especificada de {{ aspectRatio }} Pode parecer esticado ou esmagado."
  },
  "moveLayer": {
    "front": "Traga para a frente",
    "back": "Enviar para trás"
  },
  "controls": {
    "user_location": "Localização do usuário"
  },
  "deleteAttributePrompt": {
    "title": "Tem certeza de que deseja excluir esse atributo?",
    "message": "Isso removerá permanentemente os dados do atributo de todos os objetos nessa camada. Essa ação não é reversível."
  },
  "fileUpload": {
    "image_comment": "Carregar imagem para comentar",
    "invalid": "O arquivo que você enviou é inválido. Faça upload de um arquivo.png, .jpg ou .jpeg válido"
  },
  "comments": {
    "edit": "Editar comentário",
    "delete": "Excluir comentário",
    "image": "Adicionar imagem",
    "replaceImage": "Substituir imagem"
  },
  "upload_asset": {
    "icon": "ícone",
    "model": "modelo 3D",
    "upload_model": "Carregar um modelo 3D",
    "update_model": "Atualizar modelo 3D",
    "upload_icon": "Carregar um ícone",
    "update_icon": "Ícone de edição",
    "name": "Nome de {{ assetType }}",
    "categories": "Categorias",
    "search_for_categories": "Pesquisar categorias",
    "select_asset": "Selecione {{ assetType }}",
    "select_file": "Selecionar arquivo",
    "file_end": "O arquivo deve terminar em",
    "or": "ou",
    "not_support_custom_image": "O modelo que você enviou não oferece suporte a imagens personalizadas. Para ver como habilitar isso, leia o artigo ",
    "select_thumbnail": "Miniatura",
    "something_went_wrong": "Algo deu errado",
    "image_size": "Tamanho da imagem",
    "image_style": "Estilo de imagem",
    "image_file": "Arquivo de imagem",
    "enable_colour_customisation": "Habilitar a personalização de cores"
  },
  "permissionTooltip": "Você não tem permissão para ",
  "createLayerOptions": "Criar opções de camada",
  "cancelDrawing": "Cancelar desenho",
  "deleteObject": "Excluir objeto",
  "importNoWebSocketsToast": "As camadas terminaram de importar/copiar, atualize para ver as camadas",
  "refresh": "Atualizar"
}